import React, {useState} from 'react';
import styles from './style.module.scss';

interface IProps {
    value?: string
    placeHolder?: string
    isChangePerKey?: boolean
    className?: string

    onChange(value: string): void
}

const InputSearch: React.FC<IProps> = (props) => {
    const [value, setValue] = useState(props.value);
    const {placeHolder = "", isChangePerKey = true, className = ""} = props;

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const {value} = e.target;
        setValue(value);
        if (isChangePerKey)
            props.onChange(value);
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Escape') {
            clearInput();
            e.stopPropagation();
            e.preventDefault();
        }
        if (e.key === 'Enter' && !isChangePerKey)
            props.onChange(value || "");

    };

    const clearInput = () => {
        props.onChange('');
        setValue("");
    };

    return <div className={[styles.search, className].join(' ')}>
        <input placeholder={placeHolder} value={value} onChange={handleChange} onKeyDown={handleKeyDown}/>
        {(value || "").length > 0 ? <button type="button" aria-label="Clear search" className={styles.clear} onClick={clearInput}>&times;</button> :
            <span/>}
    </div>
};

export default InputSearch;
